'use strict';

import angular from 'angular';

const shortCodesServices = angular.module('applicationModule.shortCodesServices', []);

shortCodesServices.factory('ShortCodes', ['ShortCodesAPI', function (ShortCodesAPI) {
    return {
        getList: function (appId, params) {
            return ShortCodesAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (shortCodeId) {
            return ShortCodesAPI.getShortCode(shortCodeId);
        },
        save: function (shortCode, editMode) {
            return editMode ? ShortCodesAPI.editShortCode(shortCode) : ShortCodesAPI.createShortCode(shortCode);
        },
        remove: function (shortCodeId) {
            return ShortCodesAPI.removeShortCode(shortCodeId);
        },
        search: function (appId, search) {
            return ShortCodesAPI.search(appId, search);
        }
    };
}]);

shortCodesServices.service('ShortCodesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    const SHORT_CODE_URL = AppsoupAPI.API_URL + '/app/shortcodes/';

    this.getList = function (appId, params) {
        return $http.get(SHORT_CODE_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.getShortCode = function (shortCodeId) {
        return $http.get(SHORT_CODE_URL + shortCodeId);
    };

    this.createShortCode = function (shortCode) {
        return $http.post(SHORT_CODE_URL, shortCode);
    };

    this.editShortCode = function (shortCode) {
        return $http.put(SHORT_CODE_URL + shortCode.id, shortCode);
    };

    this.removeShortCode = function (shortCodeId) {
        return $http.delete(SHORT_CODE_URL + shortCodeId);
    };

    this.search = function (appId, search) {
        return $http.get(SHORT_CODE_URL + appId + '/tags', {params: {search: search}});
    };
}]);

export default shortCodesServices;
